import React, { useState, useEffect } from 'react';
import { useNavigate } from 'react-router-dom';
import { Card, Input, Button, Alert, Typography } from 'antd';
import { signInWithOTP, verifyOTP, getCurrentUser } from '../services/authService';

const { Title } = Typography;

function AdminLogin() {
  const navigate = useNavigate();
  const [email, setEmail] = useState('');
  const [code, setCode] = useState('');
  const [showCode, setShowCode] = useState(false);
  const [status, setStatus] = useState({ type: '', message: '' });
  const [loading, setLoading] = useState(false);

  useEffect(() => {
    const checkUser = async () => {
      const user = await getCurrentUser();
      if (user) {
        navigate('/admin');
      }
    };
    checkUser();
  }, [navigate]);

  const handleEmailSubmit = async e => {
    e.preventDefault();
    setLoading(true);
    setStatus({ type: '', message: '' });

    try {
      await signInWithOTP(email);
      setShowCode(true);
      setStatus({
        type: 'success',
        message: 'Check your email for the verification code!',
      });
    } catch (error) {
      setStatus({
        type: 'error',
        message: error.message,
      });
    } finally {
      setLoading(false);
    }
  };

  return (
    <div
      style={{
        maxWidth: 400,
        margin: '32px auto',
        padding: '0 16px',
      }}
    >
      <Card>
        <Title level={2} style={{ marginBottom: 24 }}>
          Admin Login
        </Title>

        {status.message && (
          <Alert
            message={status.message}
            type={status.type}
            style={{ marginBottom: 16 }}
            showIcon
          />
        )}

        {!showCode ? (
          <form onSubmit={handleEmailSubmit}>
            <Input
              type="email"
              placeholder="Email"
              value={email}
              onChange={e => setEmail(e.target.value)}
              required
              style={{ marginBottom: 16 }}
            />
            <Button type="primary" htmlType="submit" loading={loading} block>
              Send Magic Link
            </Button>
          </form>
        ) : (
          <form
            onSubmit={async e => {
              e.preventDefault();
              setLoading(true);
              try {
                await verifyOTP(email, code);
                navigate('/admin');
              } catch (error) {
                setStatus({
                  type: 'error',
                  message: error.message,
                });
              } finally {
                setLoading(false);
              }
            }}
          >
            <Input
              placeholder="Verification Code"
              value={code}
              onChange={e => setCode(e.target.value)}
              required
              style={{ marginBottom: 16 }}
            />
            <Button
              type="primary"
              htmlType="submit"
              loading={loading}
              block
              style={{ marginBottom: 8 }}
            >
              Verify Code
            </Button>
            <Button
              block
              onClick={() => {
                setShowCode(false);
                setCode('');
                setStatus({ type: '', message: '' });
              }}
            >
              Back to Email
            </Button>
          </form>
        )}
      </Card>
    </div>
  );
}

export default AdminLogin;
